// extracted by mini-css-extract-plugin
export default {"overlay":"PageBoundaryOverlay_overlay__o+m2g","band":"PageBoundaryOverlay_band__Q9ar9","label":"PageBoundaryOverlay_label__1F3mQ"};